/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function GenerateReportIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" {...props}>
      <path d="M8.33333 0H1.66667C0.75 0 0 0.75 0 1.66667V15C0 15.9167 0.75 16.6667 1.66667 16.6667H11.6667C12.5833 16.6667 13.3333 15.9167 13.3333 15V5L8.33333 0ZM10 13.3333H3.33333V11.6667H10V13.3333ZM10 10H3.33333V8.33333H10V10ZM7.5 5.83333V1.25L12.0833 5.83333H7.5Z" />
    </SvgIcon>
  );
}
